import type { Components, Theme } from '@mui/material';
import { INPUT_HEIGHT_IN_PX, INPUT_SMALL_HEIGHT_IN_PX } from '@/@mui/constants';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(!ownerState.multiline && {
        height:
          ownerState.size === 'small'
            ? INPUT_SMALL_HEIGHT_IN_PX
            : INPUT_HEIGHT_IN_PX,
      }),
    }),
    input: () => ({
      '&:-webkit-autofill': {
        height: 'inherit',
        boxSizing: 'border-box',
      },
    }),
  },
};
